import { AnyAction } from 'redux';
import { sortByProperty } from '@synergy/utils';

import { Account } from '../models/account';
import {
    RECEIVE_ACCOUNT,
    RECEIVE_ACCOUNTS,
    RECEIVE_TERMS_AND_CONDITIONS,
    REQUEST_ACCOUNTS,
    REQUEST_ACCOUNTS_COMPLETE,
    RESET_BONUS_CONDITIONS,
} from '../actions/account-actions';
import { TermsAndConditions } from '../models/terms-and-conditions';

export interface AccountReducerState {
    flat: Account[];
    sortedByName: Account[];
    termsAndConditions?: TermsAndConditions;
    inProgress: boolean;
}

const initialAccountReducerState: AccountReducerState = {
    flat: [],
    sortedByName: [],
    termsAndConditions: undefined,
    inProgress: false,
};

export const accountReducer = (
    state: AccountReducerState = initialAccountReducerState,
    action: AnyAction
): AccountReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case RECEIVE_ACCOUNTS: {
            return {
                ...state,
                flat: action['accounts'],
                sortedByName: sortByProperty({ data: action['accounts'], key: 'name' }),
            };
        }

        case RECEIVE_TERMS_AND_CONDITIONS: {
            return {
                ...state,
                termsAndConditions: rest['termsAndConditions'],
            };
        }

        case RESET_BONUS_CONDITIONS: {
            return {
                ...state,
                termsAndConditions: initialAccountReducerState.termsAndConditions,
            };
        }

        case REQUEST_ACCOUNTS: {
            return {
                ...state,
                inProgress: true,
            };
        }

        case REQUEST_ACCOUNTS_COMPLETE: {
            return {
                ...state,
                inProgress: false,
            };
        }

        case RECEIVE_ACCOUNT: {
            return {
                ...state,
                inProgress: false,
            };
        }

        default: {
            return state;
        }
    }
};
